import React from 'react';
import { NavLink } from 'react-router-dom';
import Accordion from './Accordion';
import '../assets/styles/SideBar.css';
import { AiFillProduct } from "react-icons/ai";
import { GrDocumentConfig } from "react-icons/gr";
import { IoIosExit } from "react-icons/io";
import { HiDocumentReport } from "react-icons/hi";
import { useLogout } from '../hooks/useLogout';
import { HiDocument } from "react-icons/hi";
import { HiUserCircle } from "react-icons/hi";
import { HiSearch } from "react-icons/hi";

export default function Sidebar() {
  const logout = useLogout();
  return (
    <div className="sidebar">
      <nav>

        <img src="./assets/images/logo.jpg" className="img-logo" alt="logo" />


        <NavLink to="/" end className={({ isActive }) => isActive ? 'active' : ''}>
          <AiFillProduct className="icon" /> Painel
        </NavLink>
        {/* <NavLink to="/Configuracoes" className={({ isActive }) => isActive ? 'active' : ''}>
          <GrDocumentConfig className="icon" /> Configurações
        </NavLink> */}
        <NavLink to="/Relatorios" className={({ isActive }) => isActive ? 'active' : ''}>
          <HiDocumentReport className="icon" /> Relatórios
        </NavLink>
        <NavLink to="/Consultar" className={({ isActive }) => isActive ? 'active' : ''}>
          <HiSearch className="icon" /> Consultar
        </NavLink>
       
        <Accordion title={<> <HiDocument className="icon" />Cadastro</>}>
        <NavLink to="/CadastroUsuario" className={({ isActive }) => isActive ? 'active' : ''}>
            Cad. Usuarios
          </NavLink>
          <NavLink to="/CadastroFamilia" className={({ isActive }) => isActive ? 'active' : ''}>
            Cad. Famílias
          </NavLink>
          {/* <NavLink to="/CadastroPropriedade" className={({ isActive }) => isActive ? 'active' : ''}>
            Cad. Propriedades
          </NavLink> */}
          <NavLink to="/CadastroPovoado" className={({ isActive }) => isActive ? 'active' : ''}>
            Cad. Povoados
          </NavLink>
          <NavLink to="/CadastroRegiaoCultura" className={({ isActive }) => isActive ? 'active' : ''}>
            Cad. Região/Cultura
          </NavLink>
          <NavLink to="/CadastroVisita" className={({ isActive }) => isActive ? 'active' : ''}>
            Cad. Visita/Produção
          </NavLink>
        </Accordion>
        <NavLink to="/Login" className={({ isActive }) => isActive ? 'active' : ''}>
          <HiUserCircle className="icon"/>Login
        </NavLink>
      </nav>

      <button onClick={logout}><IoIosExit className="icon" /> Sair</button>
    </div>
  );
}
